import type { ButtonProps } from '@mui/material'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AddIcon from '@mui/icons-material/Add'
import { memo } from 'react'

type Props = Omit<ButtonProps, 'startIcon'>

const AddButton = ({ children, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <Button color="primary" {...props} startIcon={<AddIcon />}>
      {children ?? t('common.add')}
    </Button>
  )
}

export default memo(AddButton)
